'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeOptions = exports.ChoroplethLegend = exports.ChoroplethChart = exports.StackedRowChart = exports.StackedBarChart = exports.HorizontalSymbolChart = exports.VerticalSymbolChart = exports.TimelineChart = exports.LineChart = exports.ScatterChart = exports.RowChart = exports.BarChart = undefined;

var _package = require('../package.json');

var _package2 = _interopRequireDefault(_package);

var _bar = require('./bar/');

var _bar2 = _interopRequireDefault(_bar);

var _row = require('./row/');

var _row2 = _interopRequireDefault(_row);

var _scatter = require('./scatter/');

var _scatter2 = _interopRequireDefault(_scatter);

var _line = require('./line');

var _line2 = _interopRequireDefault(_line);

var _timeline = require('./timeline');

var _timeline2 = _interopRequireDefault(_timeline);

var _vsymbol = require('./vsymbol');

var _vsymbol2 = _interopRequireDefault(_vsymbol);

var _hsymbol = require('./hsymbol');

var _hsymbol2 = _interopRequireDefault(_hsymbol);

var _stackedBar = require('./stacked-bar');

var _stackedBar2 = _interopRequireDefault(_stackedBar);

var _stackedRow = require('./stacked-row');

var _stackedRow2 = _interopRequireDefault(_stackedRow);

var _choropleth = require('./choropleth');

var _choropleth2 = _interopRequireDefault(_choropleth);

var _choroLegend = require('./choro-legend');

var _choroLegend2 = _interopRequireDefault(_choroLegend);

var _options = require('./utils/options');

var _options2 = _interopRequireDefault(_options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.info(_package2.default.name + '@' + _package2.default.version);

exports.BarChart = _bar2.default;
exports.RowChart = _row2.default;
exports.ScatterChart = _scatter2.default;
exports.LineChart = _line2.default;
exports.TimelineChart = _timeline2.default;
exports.VerticalSymbolChart = _vsymbol2.default;
exports.HorizontalSymbolChart = _hsymbol2.default;
exports.StackedBarChart = _stackedBar2.default;
exports.StackedRowChart = _stackedRow2.default;
exports.ChoroplethChart = _choropleth2.default;
exports.ChoroplethLegend = _choroLegend2.default;
exports.computeOptions = _options2.default;